import { render, staticRenderFns } from "./License.vue?vue&type=template&id=da5ae2aa&scoped=true"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"
import style0 from "./License.vue?vue&type=style&index=0&id=da5ae2aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5ae2aa",
  null
  
)

export default component.exports